import "core-js/modules/es.array.push.js";
import { Divider, Button } from 'ant-design-vue/es';
import { defineComponent, computed, ref, reactive, toRefs } from 'vue';
import { Goods } from '@/utils/scrollWatch';
import { useRouter } from 'vue-router';
import { mediaSchema } from './schema/footer';
export default defineComponent({
  components: {
    'a-divider': Divider,
    'a-button': Button
  },
  props: {
    from: {
      type: String,
      default: 'footer'
    }
  },
  setup(props, ctx) {
    //   console.log(Goods.footer())
    //   const footer = Goods.getters('footer')
    const windowGlobal = Goods.getters('windowGlobal');
    const boxPadding = ref(windowGlobal.boxPadding);
    const currentMedialName = ref('wx');
    const router = useRouter();
    const goLink = (path, menuTab) => {
      router.push(path);
      // if (menuTab) {
      //   Goods.dispatch('menuActive', {
      //     name: menuTab,
      //     active: true,
      //   })
      // }
    };

    const footer = computed(() => {
      if (props.from === 'footer') {
        return Goods.getters('footer').value;
      } else {
        return {
          showTime: true
        };
      }
    });
    const useMedial = reactive({
      mediaSchema,
      mediaBlurHandle(type) {
        //   console.log('type,', type)
        if (type == 'wx') {
          currentMedialName.value = 'wx';
        } else if (type === 'dy') {
          currentMedialName.value = 'dy';
        } else if (type === 'wxsp') {
          currentMedialName.value = 'wxsp';
        } else if (type === 'ks') {
          currentMedialName.value = 'ks';
        }
      }
    });
    return {
      boxPadding,
      footer,
      goLink,
      currentMedialName,
      ...toRefs(useMedial)
    };
  }
});